import type { Locale } from '@tuic/i18n';
import type { MasterExcursion } from '../../generated/oss';
import { CacheTag } from '../../utils';
import { unstable_cache } from 'next/cache';
import { Oss } from '../../index';
import { logger } from '@tuic/logger';

type Options = {
  category?: string;
  difficulty?: string;
  port?: string;
};

const getExcursionsSearchList = async (
  options: Options,
  locale: Locale,
): Promise<MasterExcursion[]> => {
  let { data, error } = await Oss.getExcursionsSearchList({
    query: {
      ...options,
      locale,
    },
  });

  if (error) {
    logger.error(
      `Could not fetch excursion search list data. Locale: ${locale}. Query: ${JSON.stringify(
        options,
      )}`,
    );
    logger.error(error);

    return [];
  }

  return data ?? [];
};

export const cachedGetExcursionsSearchList = unstable_cache(
  getExcursionsSearchList,
  ['oss', 'getExcursionsSearchList'],
  {
    tags: [
      CacheTag.oss,
      CacheTag.excursionResource,
      CacheTag.getExcursionsSearchList,
    ],
    revalidate: 600,
  },
);
